import { Label } from 'rebass'

export default Label.extend`
  color: ${props => props.theme.colors.text}
`



// WEBPACK FOOTER //
// ./src/components/Label.js